import React from "react";
import OrganisationAdminPanel from "../components/admin/OrganisationAdminPanel";

// Organisation admin (invites + membership/roles) is owned by the pDx backend
// platform (organisation-service) via src/api. The legacy Firebase-backed admin
// tooling — createInvite/getUserByEmail/updateUserRole/getClinicUsers callables
// plus direct `invites` Firestore reads — has been removed. Access is gated by
// the /admin route in App.js (canManageOrganisation), and OrganisationAdminPanel
// enforces its own permissions.
export default function AdminPage() {
  return (
    <div className="w-full h-full min-h-0 p-4 overflow-hidden mx-auto">
      <OrganisationAdminPanel />
    </div>
  );
}
